/**
 * Query an object for a specific key
 *
 * @param object
 * @param query
 * @param defaults
 * @returns {*}
 */
function queryObject(object, query, defaults = null) {
	let current = object;
	let queryParts = query.split(".");
	let part;

	if (object == undefined) {
		return defaults;
	}

	while (current && (queryParts.length > 0)) {
		part = queryParts.shift();

		if (current[part] == undefined) {
			return defaults;
		}

		current = current[part];
	}

	return current;
}

function setValueByQuery(object, query, value) {
	let parts = query.split(".");
	let key = parts.pop();
	let parentQuery = parts.join(".");
	let parent = parts.length === 0 ? object : queryObject(object, parentQuery);

	if (parent == undefined) {
		setValueByQuery(object, parentQuery, (parent = {}));
	}

	parent[key] = value;

	return object;
}

/**
 * Pluck specific keys from an object
 *
 * @param object
 * @param keys
 * @returns {{}}
 */
function pluckKeys(object, keys) {
	let newObj = {};

	keys.forEach(key => {
		if (key in object) {
			newObj[key] = object[key]
		}
	});
	return newObj;
}

/**
 * Pluck keys except specific from an object
 *
 * @param object
 * @param exceptions
 * @returns {{}}
 */
function pluckKeysExcept(object, exceptions) {
	let keys = Object.keys(object);

	exceptions.forEach(key => {
		let index = keys.indexOf(key);

		if (index !== -1) {
			keys.splice(index, 1);
		}
	});

	return pluckKeys(object, keys);
}

function decodeObservable(observable) {
	if (observable == null) {
		return observable;
	}

	const {isArray} = require("helpers/array");

	// Check if array like
	if (isArray(observable)) {
		return observable.reduce((acc, value) => {
			acc.push(decodeObservable(value));
			return acc;
		}, []);
	}

	// Check if object
	if (observable && typeof observable === "object") {
		let decoded = {};
		Object.keys(pluckKeysExcept(observable, ["$mobx"])).forEach(key => {
			decoded[key] = decodeObservable(observable[key]);
		});

		return decoded;
	}

	return observable;
}

function cloneObject(obj) {
	if (!obj || (typeof obj !== "object")) {
		return obj;
	}

	return JSON.parse(JSON.stringify(obj));
}

module.exports = {
	queryObject,
	setValueByQuery,
	pluckKeys,
	pluckKeysExcept,
	decodeObservable,
	cloneObject
};


// WEBPACK FOOTER //
// ./resources/js/helpers/object.js